<script lang="ts" setup>
  import CDefaultLayoutShell from '~/components/layout/CDefaultLayoutShell.vue'
</script>

<template>
  <CDefaultLayoutShell>
    <slot />

    <template #extras>
      <slot name="extras" />
    </template>
  </CDefaultLayoutShell>
</template>
